import Api from './baseApi';

export default {
  list: ({ tenantId, mpId }) => {
    let url = '/api/campaign-commissions';
    const params = [];

    if (tenantId) {
      params.push(`tenantId=${tenantId}`);
    }

    if (mpId) {
      params.push(`mpId=${mpId}`);
    }

    if (params.length) {
      url = `${url}?${params.join('&')}`;
    }

    return Api.get(url);
  },
  get: (id) => Api.get(`/api/campaign-commissions/${id}`),
  create: (payload) => Api.post('/api/campaign-commissions', payload),
  update: (payload) =>
    Api.put(`/api/campaign-commissions/${payload.id}`, payload),
  remove: (id) => Api.delete(`/api/campaign-commissions/${id}`),
};
